
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

type SummaryHomeworkCardData = {
  date: number
  cover: string
  text: string
}

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class SummaryHomeworkCard extends Vue {
  @Prop() dataSource

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
